import BestPracticeOverviewPage from "./BestPracticeOverviewPage"

export default BestPracticeOverviewPage
